var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8OfficePhone1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 41.5999H9.60002C7.83202 41.5999 6.40002 40.1679 6.40002 38.3999V9.5999C6.40002 7.8319 7.83202 6.3999 9.60002 6.3999H16C17.768 6.3999 19.2 7.8319 19.2 9.5999V38.3999C19.2 40.1679 17.768 41.5999 16 41.5999ZM38.4 7.9999H22.4V12.7999H36.8V15.9999H22.4V19.1999H24V22.3999H22.4V25.5999H24V28.7999H22.4V31.9999H24V35.1999H22.4V39.9999H38.4C40.168 39.9999 41.6 38.5679 41.6 36.7999V11.1999C41.6 9.4319 40.168 7.9999 38.4 7.9999ZM30.4 35.1999H27.2V31.9999H30.4V35.1999ZM30.4 28.7999H27.2V25.5999H30.4V28.7999ZM30.4 22.3999H27.2V19.1999H30.4V22.3999ZM36.8 35.1999H33.6V31.9999H36.8V35.1999ZM36.8 28.7999H33.6V25.5999H36.8V28.7999ZM36.8 22.3999H33.6V19.1999H36.8V22.3999Z",
    fill: "#22428F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 41.5999H9.60002C7.83202 41.5999 6.40002 40.1679 6.40002 38.3999V9.5999C6.40002 7.8319 7.83202 6.3999 9.60002 6.3999H16C17.768 6.3999 19.2 7.8319 19.2 9.5999V38.3999C19.2 40.1679 17.768 41.5999 16 41.5999Z",
    fill: "#FFD708"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.6002V3.2002",
    stroke: "#FFD708",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8OfficePhone1);
export default __webpack_public_path__ + "static/media/icons8-office-phone 1.5d96335f363df40edef33f5af695f438.svg";
export { ForwardRef as ReactComponent };